import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import PostInspectionDiyPriceDiscovery from "./component";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse
    }
}) => ({
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyPriceDiscovery));
